import React, { Component } from "react";
import { connect } from "react-redux";

import { getUserData } from "../../../../actions/user.actions";
import Confirmation from "../components/Confirmation";

class CompleteProfileContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.getUserData();
  }

  componentDidUpdate(props) {
    const status = _.get(props.user, "status.name");

    if (status === "approved") {
      localStorage.setItem("status", status);
      this.props.history.push("/member/projects/matches");
    }
  }

  render() {
    return <Confirmation />;
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  getUserData: () => dispatch(getUserData())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CompleteProfileContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/confirmationScreen/containers/ConfirmationContainer.js